<template>
  <div id="candleChart"></div>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "CandleChart",
  props: {
    labels: {
      type: Array,
    },
    cash_flow: {
      type: Array,
    },
    cash_flow_diff: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    loadChart() {
      var options = {
        series: [
          {
            name: "Current Year",
            type: "column",
            // data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160],
            data: this.cash_flow,
          },
          {
            name: "Difference",
            type: "line",
            // data: [23, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16],
            data: this.cash_flow_diff,
          },
        ],
        chart: {
          height: this.$vuetify.breakpoint.smAndUp ? 350 : 250,
          type: "line",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top",
            },
          },
        },
        stroke: {
          width: [0, 4],
        },
        // title: {
        //   text: "Traffic Sources",
        // },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
        },
        labels: this.labels,
        xaxis: {
          // type: "datetime",
          categories: this.labels,
        },
      };

      var chart = new ApexCharts(document.querySelector("#candleChart"), options);
      chart.render();
    },
  },
  mounted() {
    this.loadChart();
  },
};
</script>
